import React from "react";
import { Link } from 'react-router-dom'
function Menu() {
        return(
         <div>
  <nav className="navbar sticky-top navbar-expand-lg navbar-light bg-white" data-spy="affix" data-offset-top="510">
        <div className="container">
            <button className="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse mt-sm-20 navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                    <li className="nav-item">
                        <Link to="/" className="nav-link">Home</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/About" className="nav-link">About</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/Resume" className="nav-link">Resume</Link>
                    </li>
                </ul>
                <ul className="navbar-nav brand">
                    <img src="assets/imgs/avatar.jpg" alt="" className="brand-img"/>
                    <li className="brand-txt">
                        <h5 className="brand-title">John Doe</h5>
                        <div className="brand-subtitle">Web Designer | Developer</div>
                    </li>
                </ul>
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <Link to="/Portfolio" className="nav-link">Portfolio</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/Social" className="nav-link">Social</Link>
                    </li>
                    <li className="nav-item last-item">
                        <Link to="/Contact" className="nav-link">Contact</Link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
        </div>)
    }

export default Menu